import { IconInterface } from '../../interfaces/icon.interface';

export const AdminContractsRed = (props: IconInterface) => {
	const { color = '#F44A77', width = 60, height = 61 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 60 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M55.4425 32.448L56.9958 26.6513C58.8088 19.8848 59.7154 16.5015 59.0327 13.5736C58.4937 11.2618 57.2812 9.16172 55.5486 7.53898C53.3543 5.48381 49.9711 4.57727 43.2045 2.76418C36.438 0.951086 33.0547 0.0445406 30.1268 0.727228C27.815 1.26627 25.7149 2.47874 24.0922 4.21132C22.3326 6.09002 21.415 8.84033 20.0495 13.8394C19.8201 14.6791 19.5781 15.5823 19.3174 16.5554L17.7642 22.3521C15.9511 29.1186 15.0445 32.5019 15.7272 35.4298C16.2663 37.7416 17.4787 39.8417 19.2113 41.4644C21.4056 43.5196 24.7889 44.4261 31.5554 46.2392L31.5554 46.2392C37.6544 47.8734 41.0047 48.7712 43.7504 48.4325C44.051 48.3954 44.3443 48.3435 44.6331 48.2762C46.9449 47.7371 49.045 46.5247 50.6677 44.7921C52.7229 42.5978 53.6295 39.2145 55.4425 32.448Z"
				fill={color}
				fillOpacity="0.1"
				stroke={color}
			/>
			<path
				d="M44.6502 19.9485L29.0516 28.6503M32.4999 16.5L41.2017 32.0986"
				stroke={color}
				strokeLinecap="round"
			/>
			<path
				d="M43.7533 48.429C43.1277 50.3448 42.0277 52.078 40.5486 53.4633C38.3543 55.5184 34.9711 56.425 28.2045 58.2381C21.438 60.0512 18.0547 60.9577 15.1268 60.275C12.815 59.736 10.7149 58.5235 9.0922 56.7909C7.03703 54.5966 6.13048 51.2134 4.31739 44.4468L2.76418 38.6501C0.951086 31.8836 0.0445406 28.5003 0.727228 25.5724C1.26627 23.2606 2.47874 21.1606 4.21132 19.5378C6.4056 17.4827 9.78887 16.5761 16.5554 14.763C17.8356 14.42 18.9946 14.1094 20.0524 13.8359"
				stroke={color}
			/>
		</svg>
	);
};
